import uuidv1 from 'uuid/v1'
import Popup from '@/utils/popup'
import validate from '@/utils/validate'
import Hack from '@/utils/mixins/hack'
import './sms.scss'
/**
 * @description 短信发送
 * @author yangyu
 * 请复制。。。。是用为data还是props你决定
 * props: {
        value: {},
        mobile: {},
        timeout: {
            type: [Number, String],
            default: 60
        },
        beforeSend: Function // 异步函数或Promise函数，返回true或false
    }
 *
 */
export default {
  mixins: [Hack],
  watch: {
    timeout: {
      immediate: true,
      handler () {
        this.selfTimeout = this.timeout
      }
    },
    value: {
      immediate: true,
      handler () {
        if (this.currentValue !== this.value) this.currentValue = this.value
      }
    },
    currentValue () {
      this.$emit('input', this.currentValue)
    }
  },
  data () {
    return {
      currentValue: '',
      selfTimeout: 60,
      send: false, // 是否可以发送短信
      timer: null,
      sending: false // 防止重复点击
    }
  },
  beforeCreate () {
    this.inputId = uuidv1().replace(/\-/g, '_')
    this.codeId = uuidv1().replace(/\-/g, '_')
  },
  methods: {
    async open () {
      if (typeof this.beforeSend === 'function') {
        let pass = await this.beforeSend()
        if (!pass) return
      }
      if (this.send) {
        this.$emit('waitting')
        return
      }
      if (!this.inputId) this.inputId = uuidv1().replace(/\-/g, '_')
      if (!this.codeId) this.codeId = uuidv1().replace(/\-/g, '_')
      // 校验验证码
      let dialog = this.$createDialog({
        type: 'confirm',
        // icon: 'cubeic-lock',
        // showClose: true,
        title: '验证码',
        zIndex: Popup.nextZIndex(),
        onConfirm: () => {
          dialog.show()
          if (this.sending) {
            this.createToast('请不要重复点击').show()
            return
          }
          // 验证码
          let value = document.getElementById(this.inputId).value
          if (!validate(value, 'required')) {
            this.createToast('请输入验证码').show()
            return
          }
          this.sending = true
          // 校验验证码是否正确
          this.$api('member/checkVcode4reg', {
            mobile: this.mobile,
            verificationCode: value,
            data: this.smsCode ? this.smsCode : 2
          })().then(res => {
            clearInterval(this.timer)
            this.send = true
            this.timer = setInterval(() => {
              this.selfTimeout--
              if (this.selfTimeout === 0) {
                this.send = false
                this.$nextTick(() => { this.selfTimeout = 60 })
                clearInterval(this.timer)
              }
            }, 1000)
            this.sending = false
            dialog.hide()
            document.getElementById(this.inputId).value = ''
          }).catch(err => {
            this.createToast(err).show()
            this.sending = false
            document.getElementById(this.inputId).value = ''
            document.getElementById(this.codeId).src = '/eshop/pub/verificationCode/?timestamp=' + new Date().getTime()
          })
        }
      }, h => {
        let that = this
        return [
          h('input', {
            class: {
              'code-input': true
            },
            attrs: {
              placeholder: '请输入验证码',
              id: this.inputId
            },
            on: {
              blur () {
                that.handleStupidWechat4IOS12Keyboard()
              }
            },
            slot: 'content'
          }),
          h('img', {
            class: {
              'code-img': true
            },
            attrs: {
              id: this.codeId,
              alt: '验证码',
              src: '/eshop/pub/verificationCode/?timestamp=' + new Date().getTime()
            },
            on: {
              click: () => {
                document.getElementById(this.codeId).src = '/eshop/pub/verificationCode/?timestamp=' + new Date().getTime()
              }
            },
            slot: 'content'
          })
        ]
      }).show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/sms.js